import { c as _c } from "react/compiler-runtime";
import { Center, Heading, Separator, Spinner, VStack } from '@chakra-ui/react';
import { SidebarNestedNavList, SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import React from 'react';
import { LuBriefcase, LuHammer, LuHand, LuRocket, LuUser } from 'react-icons/lu';
type OnboardingNavProps = {};
export const onboardingNavItems: SidebarNestedNavListSection[] = [{
  title: 'Start Here',
  icon: () => <LuHand />,
  href: `/onboarding/welcome`
},
// {
//   title: 'Schedule Intro Call',
//   icon: () => <LuPhoneCall />,
//   href: `/onboarding/schedule-call`,
// },
// {
//   icon: () => <LuTags />,
//   title: 'Topics of Interest',
//   href: '/onboarding/topics',
// },
// {
//   icon: () => <LuBook />,
//   title: 'Choose Your Sprint',
//   href: '/onboarding/sprint',
// },
{
  title: 'Personal Profile',
  icon: () => <LuUser />,
  href: `/onboarding/profile`
}, {
  title: 'Startup Profile',
  icon: () => <LuBriefcase />,
  href: `/onboarding/startup`
}, {
  title: 'Skills & Experiences',
  icon: () => <LuHammer />,
  href: `/onboarding/skills`
}, {
  title: 'Get Involved',
  icon: () => <LuRocket />,
  href: `/onboarding/get-involved`
}].filter(Boolean);
export const OnboardingNav = props => {
  const $ = _c(2);
  const {
    currentUser
  } = useCurrentUser();
  if (!currentUser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Center paddingY="10em"><Spinner /></Center>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VStack align="stretch" gap={0} justify="stretch" width="full"><Heading marginY={2} padding={3} size="sm">Account Setup</Heading><Separator marginBottom={2} /><SidebarNestedNavList sections={onboardingNavItems} /></VStack>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};